import React, { useEffect, useState } from "react";
import styles from "./AdProviderConfiguration.module.css";
import AdPositions from "./AdPositions";
import AdProviderConfig from "./AdProviderConfig";
import Button from "../../component/button/Button";
import useUrlTab from "../../hooks/useUrlTab";

const TABS = ["providers", "positions"];

const AdProviderConfiguration = () => {
  const [activeTab, setActiveTab] = useUrlTab(TABS, "providers");
  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.title}>Ad Management Configuration</h2>
        <p className={styles.subtitle}>
          Configure ad servers and provider settings
        </p>
      </div>

      {/* Tabs (always visible) */}
      <div className={styles.tabs}>
        <Button
          className={activeTab === "providers" ? styles.activeTab : ""}
          onClick={() => setActiveTab("providers")}
        >
          Providers
        </Button>
        <Button
          className={activeTab === "positions" ? styles.activeTab : ""}
          onClick={() => setActiveTab("positions")}
        >
          Ad Positions
        </Button>
      </div>

      {/* Content */}
      <div className={styles.content}>
        {activeTab === "providers" && (
          <AdProviderConfig  />
        )}
        {activeTab === "positions" && <AdPositions  />}
      </div>
    </div>
  );
};

export default AdProviderConfiguration;
